import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { matchesCsvUrl, mmrCsvUrl } from "../lib/api";
import { SeasonWrappedModal } from "./SeasonWrappedModal";

/**
 * PremiumExportsCard — left-column block exposing the Wave D PRO perks:
 *   - Season Wrapped modal
 *   - Matches CSV
 *   - MMR history CSV
 *
 * For non-PRO users we render a soft paywall that nudges to /pricing. The
 * server enforces PRO on every endpoint regardless.
 */
export function PremiumExportsCard({ onToast }) {
  const { user } = useAuth();
  const [wrappedOpen, setWrappedOpen] = useState(false);
  const isPro = !!(user?.is_pro || ["pro", "elite"].includes((user?.plan || "").toLowerCase()));

  return (
    <div className="glass rounded-3xl p-4" data-testid="dash-premium-exports">
      <div className="flex items-center justify-between mb-2">
        <p className="text-[10px] tracking-[3px] text-[#14b8a6] font-bold">
          <i className="fas fa-crown mr-1" />PRO EXPORTS
        </p>
        <span className={`text-[9px] tracking-widest px-2 py-0.5 rounded-md font-bold ${
          isPro ? "bg-[#14b8a6]/15 text-[#14b8a6] border border-[#14b8a6]/40"
                : "bg-white/5 text-white/55 border border-white/15"
        }`}
              data-testid="premium-exports-state">
          {isPro ? "● UNLOCKED" : "○ PRO"}
        </span>
      </div>
      <p className="text-[11px] text-white/55 mb-3">
        Year-end Wrapped recap + shareable cards + raw CSV exports.
      </p>

      {isPro ? (
        <div className="space-y-1.5">
          <button type="button"
                  onClick={() => setWrappedOpen(true)}
                  data-testid="open-wrapped-btn"
                  className="w-full text-left text-[11px] tracking-widest px-3 py-2 rounded-xl bg-[#14b8a6]/15 text-[#a39cff] hover:bg-[#14b8a6]/25 border border-[#14b8a6]/30 transition">
            <i className="fas fa-sparkles mr-1.5" />SEASON WRAPPED <span className="text-white/40 float-right">›</span>
          </button>
          <a href={matchesCsvUrl()} target="_blank" rel="noreferrer"
             data-testid="dl-matches-csv-btn"
             className="block w-full text-[11px] tracking-widest px-3 py-2 rounded-xl bg-[#14b8a6]/10 text-[#14b8a6] hover:bg-[#14b8a6]/20 border border-[#14b8a6]/25 transition">
            <i className="fas fa-file-csv mr-1.5" />MATCHES.CSV <span className="text-white/40 float-right">↓</span>
          </a>
          <a href={mmrCsvUrl()} target="_blank" rel="noreferrer"
             data-testid="dl-mmr-csv-btn"
             className="block w-full text-[11px] tracking-widest px-3 py-2 rounded-xl bg-[#14b8a6]/10 text-[#14b8a6] hover:bg-[#14b8a6]/20 border border-[#14b8a6]/25 transition">
            <i className="fas fa-file-csv mr-1.5" />MMR-HISTORY.CSV <span className="text-white/40 float-right">↓</span>
          </a>
        </div>
      ) : (
        <a href="/pricing"
           data-testid="exports-upsell-btn"
           className="block text-center text-[11px] tracking-widest px-3 py-2 rounded-xl bg-gradient-to-r from-[#14b8a6] to-[#14b8a6] text-black font-bold hover:brightness-110 transition">
          <i className="fas fa-lock mr-1.5" />UPGRADE TO UNLOCK
        </a>
      )}

      <SeasonWrappedModal open={wrappedOpen} onClose={() => setWrappedOpen(false)} onToast={onToast} />
    </div>
  );
}

export default PremiumExportsCard;
